'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _vanillaTilt = require('vanilla-tilt');

var _vanillaTilt2 = _interopRequireDefault(_vanillaTilt);

var _utils = require('../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el;

  if (window.innerWidth > _utils.mediaBreakpoints.md) {
    _vanillaTilt2.default.init(document.querySelectorAll('.js-PerspectiveTilt_Item'), {
      max: 10,
      speed: 400,
      scale: 0.95,
      glare: true,
      'max-glare': 0.02
    });

    _vanillaTilt2.default.init(document.querySelectorAll('.js-PerspectiveTilt_Item-strong'), {
      max: 10,
      speed: 400,
      scale: 0.95,
      glare: true,
      'max-glare': 0.8
    });
  } else {
    _vanillaTilt2.default.init(document.querySelectorAll('.js-PerspectiveTilt_Item, .js-PerspectiveTilt_Item-strong'), {
      max: 13,
      speed: 400,
      scale: 0.95
    });
  }
}